module.exports = __webpack_public_path__ + "images/dcbc07169fa04164c7d4f4fa3f929ef2-poland-country-brand-logo.jpg";